import { Link } from 'react-router';
import { Pill, Tooltip } from '@/components/ui';
import { trialLeft, useTrial } from '@/plan/trial';

/**
 * A quiet "Trial · 5 days left" beside the account while any trial runs (TW-13). The banner only speaks up in the last
 * three days, which left a new account not knowing it was on a trial at all. Phones show the word alone.
 */
export function TrialBadge() {
  const trial = useTrial();
  if (!trial) return null;
  const left = trialLeft(trial);
  const full = `${trial.team ? 'Team trial' : 'Free trial'}, ${left}`;
  return (
    <Tooltip label={trial.team ? `${full}. No card is charged until it ends.` : `${full}. Upgrade any time; your data stays either way.`}>
      <Link to={trial.to} aria-label={full} className="group inline-flex no-underline rounded-chip">
        <Pill tone="notice" className="group-hover:underline">Trial<span className="hidden sm:inline">&nbsp;· {left}</span></Pill>
      </Link>
    </Tooltip>
  );
}
